import style from './style.module.css'
import classNames from 'classnames'
import Accordion from '../Accordion'
import FAQAccordionDetails from './FAQAccordionDetails'
import { Header, Button } from '@crossfit/ui'

type Question = {
  headlineText: string
  questionText: string
  className?: string
}

type Button = {
  text: string
  url: string
}

export type Props = {
  headline: string
  questions: Question[]
  className?: string
  button?: Button
}

function formatAccordionItems(questions: Question[]) {
  return questions.map((question) => {
    return {
      className: question.className,
      details: <FAQAccordionDetails questionText={question.questionText} />,
      summary: question.headlineText,
    }
  })
}

function FAQModule(props: Props) {
  const { button, className, headline, questions } = props
  const accordionItems = formatAccordionItems(questions)

  return (
    <div className={classNames(style.wrapper, className)}>
      <div className={classNames(style.innerContent, className)}>
        <Header as='h3' size='medium' mb={6}>
          {headline}
        </Header>
        <Accordion
          className={style.accordion}
          items={accordionItems}
          showBottomBorders
          variant='white-condensed-card'
        />
        {button && (
          <Button url={button.url} variant='primaryBlue'>
            {button.text}
          </Button>
        )}
      </div>
    </div>
  )
}

export default FAQModule
